<template>
  <div class="back" style="height: 100vh">
    <v-toolbar
      color="blue-grey"
      class="elevation-2"
      height="56px"
      style="position: fixed; top: 0; left: 0; width: 100vw; z-index: 10"
    >
      <div
        class="blue-grey"
        style="height: 30px; width: 55px; position: fixed; top: 34px; left: 0"
      />
      <v-spacer></v-spacer>
      <v-toolbar-title>
        <H1 class="display-2 text-center grey--text text--lighten-4">
          Gestion Électronique des Documents Financiers et Comptables
        </H1>
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-row class="pa-12">
      <v-col style="position: fixed; top: 120px; left: 90px">
        <v-img
          eager
          transition="fab-transition"
          width="30vw"
          src="static/img/logo.png"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "Home",
};
</script>
<style scoped>
.back {
  background: url("/static/img/research-5297028_1920.jpg") no-repeat center
    center fixed;
  background-size: cover;
}
</style>
